import { StatusContent } from "../../constants";

interface Props {
  currentView: StatusContent;
}

export default function StatusFeedbackView({ currentView }: Props) {
  const StatusIcon = currentView.icon;

  return (
    <div className="flex flex-col flex-1 w-full animate-in zoom-in-95 duration-500 font-['Mulish']">
      <div className="flex-1 flex flex-col items-center justify-center gap-11 w-full mb-8">
        <div className="bg-white rounded-2xl flex flex-col gap-6 items-center justify-center border border-[#E2E8F0] shadow-[0px_4px_4px_0px_#0000001A] w-full p-6 text-center">
          <div className="flex flex-col justify-center items-center">
            <StatusIcon size={58} strokeWidth={1.5} className={`${currentView.iconClass} mb-2 text-white`} />
            <h2 className="text-lg font-semibold pb-2 tracking-wide">{currentView.title}</h2>
            <span className="text-[#8A8989] mx-10 leading-[1.3] text-sm text-center">{currentView.description}</span>
          </div>

          {currentView.footerText && (
            <div className={`rounded-md py-2 px-5 text-xs w-full text-center flex items-center justify-center ${currentView.footerBgClass} ${currentView.footerTextClass}`}>
              <span>{currentView.footerText}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}